import {
    SET_STEPS,
    SET_STEP,
    SET_STEP_COMPLETED,
    SET_STEPS_UNCOMPLETED,
    LOAD_APPLICATION_DATA_PENDING,
    LOAD_APPLICATION_DATA_FULFILLED,
} from '../../constants/ActionTypes';
import formStepperInitialState from './formStepperInitialState';

function stepperReducer(state = formStepperInitialState, action) {
    switch (action.type) {
    case SET_STEPS:
        return {
            ...state,
            activeStep: action.data.activeStep,
            // steps: Object.assign([], state.steps, action.data.steps),
        };
    case SET_STEP:
        return {
            ...state,
            activeStep: action.step,
        };
    case SET_STEP_COMPLETED: {
        const steps = [...state.steps];
        steps[action.step].completed = action.status;
        return {
            ...state,
            steps,
        };
    }
    case SET_STEPS_UNCOMPLETED: {
        const stepsMap = {
            0: [1, 1, 0, 0, 1, 1, 0, 0, 1],
            3: [0, 0, 0, 1, 1, 0, 1, 0, 1],
            5: [0, 0, 0, 0, 0, 1, 0, 0, 1],
            6: [0, 0, 0, 0, 0, 0, 1, 0, 0],
            7: [0, 0, 0, 0, 0, 0, 0, 1, 1],
        };
        const steps = state.steps.map((step, index) => ({
            ...step,
            completed: stepsMap[action.fromStep] && stepsMap[action.fromStep][index]
                ? false
                : step.completed,
        }));
        return {
            ...state,
            steps,
        };
    }
    case LOAD_APPLICATION_DATA_PENDING: {
        return {
            ...state,
            isPending: true,
        };
    }
    case LOAD_APPLICATION_DATA_FULFILLED: {
        return {
            ...state,
            isPending: false,
        };
    }
    default:
        return state;
    }
}

export default stepperReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/formStepperReducer.js